@if (isCompany()) {
  @if (!severalMatches()) {
    <span>{{ 'screening.case.forms.entity_match_decision_type.company_title' | translate }}</span>
  } @else {
    <span>{{ 'screening.case.forms.entity_match_decision_type.company_title_several_matches' | translate }}</span>
  }
} @else {
  @if (!severalMatches()) {
    <span>{{ 'screening.case.forms.entity_match_decision_type.person_title' | translate }}</span>
  } @else {
    <span>{{ 'screening.case.forms.entity_match_decision_type.person_title_several_matches' | translate }}</span>
  }
}
